export class DeptRequest{
    deptId: number;

    constructor(deptId: number){
        this.deptId = deptId;
    }
}